import { Logo } from "@/components/brand/Logo";

export function LoadingScreen() {
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-3 animate-fade-in">
        <Logo className="h-9 w-9 animate-pulse text-primary" />
        <span className="text-sm text-muted-foreground tracking-wide">
          Loading...
        </span>
      </div>
    </div>
  );
}
